module.exports = __webpack_public_path__ + "img/serious-illness.1d8da96.svg";